import {useNavigate} from "react-router-dom";
import {customNoAuthAxios} from "../../utils/customNoAuthAxios";
import {SelectedQuestions} from "./useFetchManlaboSurveySelectedQuestionsCustomerByRestaurantId";
import {ManLaboSetting} from "./useFetchManlaboSettingCustomerByRestaurantId";
import liff from '@line/liff';

export const useAnswerManLaboSurvey = (
    restaurantId: string,
    selectedQuestions: SelectedQuestions,
    lineAccountId: string,
    setting: ManLaboSetting,
    debugFlag?: boolean
) => {
    const navigate = useNavigate();

    const onSubmit = async (data: any) => {
        const questions = selectedQuestions.map(selectedQuestion => selectedQuestion.question);
        data['restaurant_id'] = restaurantId;
        data['line_account_id'] = lineAccountId;
        data['questions'] = questions;

        const debug =
            typeof debugFlag === 'boolean'
                ? debugFlag
                : (process.env.REACT_APP_MANLABO_DEBUG === 'true');

        // バックエンドの「生レスポンス」を確認
        if (debug) {
            const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
            const endpoint = `${apiBase}/manzokudo_labo/restaurants/${restaurantId}/setting/customer/`.replace(/([^:]\/)\/+/g, '$1');
            try {
                const res = await fetch(endpoint, { method: 'GET', credentials: 'omit' });
                const text = await res.text();
                let parsed: any = null;
                try { parsed = JSON.parse(text); } catch { /* JSON でない場合も表示 */ }
                const keys = parsed ? Object.keys(parsed).join(', ') : '(parse failed)';
                const defaultUrlValue = parsed ? String(parsed.default_url) : '(N/A)';
                const defaultUrlType = parsed ? typeof parsed.default_url : '(N/A)';
                alert(
`[ManLabo Debug | backend response]
GET ${endpoint}
status: ${res.status}
keys: ${keys}
default_url: ${defaultUrlValue} | type=${defaultUrlType}
raw body:
${text}`
                );
            } catch (e: any) {
                alert(`[ManLabo Debug] backend fetch error: ${e?.message ?? String(e)}`);
            }
        }

        // 以降は従来処理（略）。ここから下は既存の分岐＋URL検証をそのまま維持
        const normalize = (u: any) => (typeof u === 'string' ? u.trim() : '');
        const isHttpUrl = (u: string) => {
            try {
                const parsed = new URL(u);
                return parsed.protocol === 'http:' || parsed.protocol === 'https:';
            } catch {
                return false;
            }
        };

        const rawGUrl: any = (setting as any)?.g_url ?? (setting as any)?.gUrl ?? null;
        const rawDefaultUrl: any =
            (setting as any)?.default_url ??
            (setting as any)?.defaultUrl ??
            (setting as any)?.default_en_url ??
            null;

        const gUrl = normalize(rawGUrl);
        const defaultUrl = normalize(rawDefaultUrl);

        try {
            await customNoAuthAxios.post('manzokudo_labo/survey/answers/customer/', data);

            const branchQuestionIndex = questions.findIndex(q => q === setting.branch_question);
            if (branchQuestionIndex < 0) {
                if (defaultUrl && isHttpUrl(defaultUrl)) {
                    window.location.href = defaultUrl;
                } else {
                    navigate('/thanks', { replace: true });
                }
                return;
            }

            const branchQuestionScore = Number(data.survey?.[branchQuestionIndex]?.answer_score ?? 0);
            const shouldGoGUrl =
                branchQuestionScore > setting.branch_score &&
                setting.is_navigate_g_url &&
                !!gUrl;

            if (shouldGoGUrl) {
                if (isHttpUrl(gUrl)) {
                    await liff.openWindow({ url: gUrl, external: true });
                    setTimeout(() => { try { liff.closeWindow(); } catch {} }, 200);
                } else {
                    navigate('/thanks', { replace: true });
                }
            } else {
                if (defaultUrl && isHttpUrl(defaultUrl)) {
                    window.location.href = defaultUrl;
                } else {
                    navigate('/thanks', { replace: true });
                }
            }
        } catch {
            navigate('/thanks', { replace: true });
        }
    };

    return onSubmit;
};
